import React, { useState } from "react";
import { SidebarChatbotDrawer } from "../sidebar-chatbot-drawer";
// import { AnswersChatContent } from "../answers-chat-content";
import AssistantChatContent from "./AssistantChatContent";
import { useAssistantChat } from "./useAssistantChat";

const AssistantSidebar: React.FC = () => {
  const { isAssistantEnabled, ...chat } = useAssistantChat();
  const [headerActions, setHeaderActions] = useState<React.ReactNode>(null);

  if (!isAssistantEnabled) {
    return null;
  }

  return (
    <SidebarChatbotDrawer headerActions={headerActions}>
      <AssistantChatContent chat={chat} onHeaderActions={setHeaderActions} />
      {/* <AnswersChatContent onHeaderActions={setHeaderActions} /> */}
    </SidebarChatbotDrawer>
  );
};

export default AssistantSidebar;
